// wait for animation frame
export default function waf() {
  return new Promise(requestAnimationFrame);
}
